import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'companyProductUserMemberRoleToColorPipe' })
export class CompanyProductUserMemberRoleToColorPipe implements PipeTransform {
  transform(dc: string | null | undefined): string {
    switch (dc) {
      case 'assistant-manager':
        return '#3498db';
      case 'cco':
      case 'ceo':
      case 'cfo':
      case 'chro':
      case 'cmo':
      case 'coo':
      case 'cso':
      case 'cto':
        return '#3498db';
      case 'developer':
        return '#3498db';
      case 'product-designer':
        return '#8e44ad';
      case 'product-manager':
        return '#3498db';
      case 'tech-lead':
        return '#3498db';
      default:
        return '#C1C1C1';
    }
  }
}
